import React, { useState, useEffect } from 'react';
import { IProps } from './types';
import CustomTextElement from '../CustomTextElement';
import { UpperCase } from 'routes/private/Editor/Editor/CommandsBars/TextCommandBar/CommandsOptions/FontUppercaseCommandOption/types'
import { superSupFactor } from 'utils/textMultiStyling'

const TextSegmentElement: React.FC<IProps> = (props) => {

  const getTextFormat = () => {
    return (props.segment.style.fontUpperCase && props.segment.style.fontUpperCase === UpperCase.allcaps)
            ? props.segment.text.toUpperCase()
            : props.segment.text;
  }
 
  const fontSize = ((props.segment.style.fontSize && (props.segment.style.subscript || props.segment.style.superscript))?(props.segment.style.fontSize*superSupFactor):props.segment.style.fontSize);
  return (
    <CustomTextElement
      id={props.element.id + "-" + props.segmentIndex.toString() + "-textPart"}
      x={props.segment.x}
      y={props.segment.y}
      //height={props.segment.height}
      text={getTextFormat()}     
      visible={!props.element.attributes.hidden}
      opacity={props.element.attributes.opacity}
      fontFamily={`font-${props.segment.style.fontFamily}`}
      fontSize={fontSize??0}
      fontItalic={props.segment.style.fontItalic}
      fontBold={props.segment.style.fontWeight}
      fontUnderline={props.segment.style.fontUnderline}
      fill={props.segment.style.color}  
      letterSpacing={props.segment.style.letterSpacing}
      lineHeight={props.segment.style.lineHeight}
    />
  );
}

export default TextSegmentElement;